import { Card, Row, Col, Statistic, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
// import { CheckCircleTwoTone } from '@ant-design/icons'

const { Text } = Typography

const ApprovalKpis = ({ data, loading }) => {
  const { totalStrategies, activeStrategies, avgLevels /*compliance*/ } = data
  const { t } = useTranslation()

  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={6}>
        <Card loading={loading} style={cardStyle}>
          <Text strong>{t('CONFIG_APPROVALS_KPIS_STRATEGY_TOTAL')}</Text>
          <Statistic value={totalStrategies} valueStyle={{ fontSize: 36 }} />
          <Text type="secondary">{t('CONFIG_APPROVALS_KPIS_CONFIG_STRATEGIES')}</Text>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card loading={loading} style={cardStyle}>
          <Text strong>{t('CONFIG_APPROVALS_KPIS_ACTIVE_STRATEGIES')}</Text>
          <Statistic
            value={activeStrategies?.value}
            valueStyle={{ fontSize: 36, color: '#00a854' }}
          />
          <Text type="secondary">
            {activeStrategies?.percentage}
            {t('CONFIG_APPROVALS_KPIS_PERCENTAGE_TOTAL')}
          </Text>
          <br />
          <Text type="link">
            +{activeStrategies?.newLast30Days}
            {t('CONFIG_APPROVALS_KPIS_NEW')}
          </Text>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card loading={loading} style={cardStyle}>
          <Text strong>{t('CONFIG_APPROVALS_KPIS_AVERAGE_LEVELS')}</Text>
          <Statistic
            value={avgLevels}
            precision={1}
            valueStyle={{ fontSize: 36, color: '#1f4eff' }}
          />
          <Text type="secondary">{t('CONFIG_APPROVALS_KPIS_APPROVAL_LEVELS')}</Text>
        </Card>
      </Col>

      {/* <Col xs={24} sm={12} lg={6}>
        <Card style={cardStyle}>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text strong>Cumplimiento</Text>

            <Row align="middle" justify="space-between">
              <Col span={12}>
                <Statistic
                  value={compliance.percentage}
                  suffix="%"
                  valueStyle={{ fontSize: 36, color: '#1f4eff' }}
                />
                <Text type="secondary">Configuradas correctamente</Text>
              </Col>

              <Col span={12}>
                <Space direction="vertical" size="large">
                  <Text>
                    <CheckCircleTwoTone twoToneColor="#00a854" /> Correctas: {compliance.correct}
                  </Text>
                  <Text type="danger">● Incompletas: {compliance.incomplete}</Text>
                </Space>
              </Col>
            </Row>
          </Space>
        </Card>
      </Col> */}
    </Row>
  )
}

export default ApprovalKpis
